<template>
  <div class="mm-row-block">
    <el-form label-width="100px" label-position="left">
      <div class="form-isheader-group">
        <div class="group-title">
          <h3>基本資料</h3>
        </div>
        <div class="form-isheader-group-content">
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="電話號碼" prop="phone">
                <el-input disabled="" v-model="data.phone">
                  <el-button slot="append" @click="copyText(data.phone)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="會員姓名" prop="name">
                <el-input disabled="" v-model="data.name">
                  <el-button slot="append" @click="copyText(data.name)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="英文名稱" prop="ename">
                <el-input disabled="" clearable v-model="data.ename">
                  <el-button slot="append" @click="copyText(data.ename)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="稱謂" prop="appellations">
                <el-select class="elselect" disabled="" v-model="data.appellations" clearable placeholder="請選擇" :popper-append-to-body="false">
                  <el-option :label="'先生'" :value="1"></el-option>
                  <el-option :label="'女士'" :value="2"></el-option>
                  <el-option :label="'小姐'" :value="3"></el-option>
                  <el-option :label="'太太'" :value="4"></el-option>
                  <el-option :label="'其他'" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="國籍" prop="country_id">
                <el-input v-if="data.country_ename && data.country_twname" disabled="" :value="data.country_ename+'-'+data.country_twname"></el-input>
                <el-input v-else disabled=""></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="身份證或護照" prop="card">
                <el-input disabled="" v-model="data.card">
                  <el-button slot="append" @click="copyText(data.card)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="住址" prop="address">
                <el-input disabled="" v-model="data.address">
                  <el-button slot="append" @click="copyText(data.address)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="代理" prop="agent">
                <div style="margin:10px 0">
                  <el-switch style="display: block" disabled v-model="data.agent" active-color="#13ce66" inactive-color="#ff4949" active-text="是" inactive-text="否" active-value="1" inactive-value="0">
                  </el-switch>
                </div>
              </el-form-item>
            </div>
          </div>
        </div>
      </div>

      <div class="form-isheader-group">
        <div class="group-title">
          <h3>會員文件</h3>
        </div>
        <div class="form-isheader-group-content">
          <el-upload disabled action="#" :file-list="files1" list-type="picture-card" :auto-upload="false" :on-preview="viewpic" :on-remove="delpic">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="showpicbox" :append-to-body="true">
            <img width="100%" :src="showpicurl" alt="">
          </el-dialog>

        </div>
      </div>
      <div class="form-isheader-group">
        <div class="group-title">
          <h3>審查結果 Name Screening Result</h3>
        </div>
        <div class="form-isheader-group-content">
          <div style="margin-bottom: 20px;">
            <div class="group-sub-title">
              <h3>OFAC</h3>
            </div>
            <el-table empty-text="暫無數據" :data="examinedata" border :header-cell-style="{background:'#FAFAFA'}">
              <el-table-column label="Name" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Name</div>
                  <span>{{scope.row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Address" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Address</div>
                  <span>{{scope.row.address}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Type" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Type</div>
                  <span>{{scope.row.type}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Program(s)" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Program(s)</div>
                  <span>{{scope.row.program}}</span>
                </template>
              </el-table-column>
              <el-table-column label="List" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">List</div>
                  <span>{{scope.row.list}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Score" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Score</div>
                  <span style="color:red" v-if="scope.row.score>90">{{scope.row.score}}</span>
                  <span v-if="scope.row.score<=90 && scope.row.score>0">{{scope.row.score}}</span>
                  <span style="color:green" v-if="scope.row.score==0">{{scope.row.score}}</span>
                </template>
              </el-table-column>
              <el-table-column label="url" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">url</div>
                  <span v-if="scope.row.url"><a :href="scope.row.url" target="_blank">{{scope.row.url}}</a></span>
                </template>
              </el-table-column>
              <el-table-column label="Query Time" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Query Time</div>
                  <span v-if="scope.row.addtime">{{scope.row.addtime}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-bottom: 20px;">
            <div class="group-sub-title">
              <h3>UNSC</h3>
            </div>
            <el-table empty-text="暫無數據" :data="examinedataxml" border :header-cell-style="{background:'#FAFAFA'}">
              <el-table-column label="Name" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Name</div>
                  <span>{{scope.row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Type" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">type</div>
                  <span>{{scope.row.type}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Design" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">design</div>
                  <span>{{scope.row.design}}</span>
                </template>
              </el-table-column>

              <el-table-column label="Date" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">date</div>
                  <span>{{scope.row.date}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Score" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Score</div>
                  <span style="color:red" v-if="scope.row.score>90">{{scope.row.score}}</span>
                  <span v-if="scope.row.score<=90 && scope.row.score>0">{{scope.row.score}}</span>
                  <span style="color:green" v-if="scope.row.score==0">{{scope.row.score}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Url" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">url</div>
                  <span v-if="scope.row.url"><a :href="scope.row.url" target="_blank">{{scope.row.url}}</a></span>
                </template>
              </el-table-column>
              <el-table-column label="Query Time" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Query Time</div>
                  <span>{{scope.row.addtime}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-upload disabled action="#" :file-list="files2" list-type="picture-card" :auto-upload="false" :on-preview="viewpic" :on-remove="delpic">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="showpicbox" :append-to-body="true">
            <img width="100%" :src="showpicurl" alt="">
          </el-dialog>
        </div>
      </div>

    </el-form>
  </div>

</template>

<script>

export default {
  props: ['data'],
  name: "person",
  data () {
    return {
      showpicurl: '',
      showpicbox: false,
      examinedata: [],
      examinedataxml: [],
      files1: [],
      files2: [],
    }
  },
  methods: {
    delpic (file, fileList) {

    },
    viewpic (file) {
      this.showpicurl = file.url;
      this.showpicbox = true;
    },
    copyText (text) {
      const oInput = document.createElement('input')
      oInput.value = text;
      document.body.appendChild(oInput)
      oInput.select()
      document.execCommand('Copy')
      // 提醒信息
      this.$notify({
        message: '複製成功',
        type: 'success',
        duration: 3000,
        offset: 70
      });
      oInput.remove()
    },

  },
  created () {
    this.examinedata = this.data.examinedata;
    this.examinedataxml = this.data.examinedataxml;
    this.data.files.map((v) => {
      if (v.type == 1) {
        let file = {
          name: '',
          url: this.apiurl + v.fileurl
        }
        this.files1.push(file);
      } else if (v.type == 2) {
        let file = {
          name: '',
          url: this.apiurl + v.fileurl
        }
        this.files2.push(file);
      }
    })
  }
}
</script>

<style scoped>
.flex50 {
  flex: 0 50%;
}
@media screen and (max-width: 1024px) {
}
</style>
